const MenuCategorySkeleton = () => {
  return (
    <div className="grid grid-cols-1 gap-4 p-5 md:grid-cols-2 xl:grid-cols-3">
      {[1, 2, 3].map((item) => (
        <div
          key={item}
          className="h-52 animate-pulse rounded-xl bg-gray-2 dark:bg-meta-4"
        />
      ))}
    </div>
  );
};

export default MenuCategorySkeleton;
